const temperaturelabel = (temp) => {
  let temperature = Math.round(temp);
  return `${temperature}°`;
};

export { temperaturelabel };
